
    <div class="read-more-text" [innerHTML]="visibleContent"></div>
    <a *ngIf="showToggle" class="more-info-link" (click)="toggleContent($event)">
      {{ (isCollapsed ? 'COMMON.READ_MORE' : 'COMMON.READ_LESS') | translate }}
    </a>
  